var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.375 5.62539C57.375 6.18789 65.8125 10.6879 72 16.8754C79.3125 24.7504 83.25 34.3129 83.25 45.5629C83.25 54.5629 79.875 63.0004 74.25 70.3129C68.625 77.0629 60.75 82.1254 51.75 83.8129C42.75 85.5004 33.75 84.3754 25.875 79.8754C18 75.3754 11.8125 68.6254 8.4375 60.1879C5.0625 51.7504 4.5 42.1879 7.3125 33.7504C10.125 24.7504 15.1875 17.4379 23.0625 12.3754C30.375 7.31289 39.375 5.06289 48.375 5.62539ZM51.1875 78.1879C58.5 76.5004 65.25 72.5629 70.3125 66.3754C74.8125 60.1879 77.625 52.8754 77.0625 45.0004C77.0625 36.0004 73.6875 27.0004 67.5 20.8129C61.875 15.1879 55.125 11.8129 47.25 11.2504C39.9375 10.6879 32.0625 12.3754 25.875 16.8754C19.6875 21.3754 15.1875 27.5629 12.9375 35.4379C10.6875 42.7504 10.6875 50.6254 14.0625 57.9379C17.4375 65.2504 22.5 70.8754 29.25 74.8129C36 78.7504 43.875 79.8754 51.1875 78.1879ZM44.4375 42.1879L57.9375 28.1254L61.875 32.0629L48.375 46.1254L61.875 60.1879L57.9375 64.1254L44.4375 50.0629L30.9375 64.1254L27 60.1879L40.5 46.1254L27 32.0629L30.9375 28.1254L44.4375 42.1879Z",
    fill: "#F24E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a11fdfa6ed0d5cdcd9001c5feed7f6fb.svg";
export { ForwardRef as ReactComponent };